<template>
  <div>
    <!-- <var-button type="primary" block @click="toggleTheme">
      切换主题
    </var-button>

    <var-button type="info" block style="margin-top: 12px" @click="toggleBrandTheme">
      切换主题色
    </var-button> -->
  </div>
</template>

<script setup>
import { useSettingStore } from 'd3components'

const settingStore = useSettingStore()

function toggleTheme() {
  const isDark = settingStore.displayMode === 'dark'
  settingStore.toggleDark(!isDark)
}

function toggleBrandTheme() {
  settingStore.brandTheme = settingStore.brandTheme === 'blue' ? 'green' : 'blue'
  settingStore.updateConfig({})
}
</script>
